// extracted by mini-css-extract-plugin
export default {"cautionDiv":"AnnoucementList_cautionDiv__61Qwf","noticeDiv":"AnnoucementList_noticeDiv__T622r","warningDiv":"AnnoucementList_warningDiv__bbycr"};